function addressToggle(){
  $('.address-actions .edit-link').on('click', function(e) {
    e.preventDefault();
    const $this = $(this);
    const $address = $this.closest('.customer__address');
    const $editAddress = $address.next('.edit-address');
    const dataDefault = $editAddress.find('select[name="address[province]"]').data('default');
    const $provinceSelect = $editAddress.find('select[name="address[province]"]');
    $editAddress.stop(true).slideToggle()
    $editAddress.find('select[name="address[country]"]').trigger('change');
    $provinceSelect.val(dataDefault);
  })

  $('.add-new-address').on('click', function(e) {
    e.preventDefault();
    $('#address_form_new').stop(true).slideToggle()
  })

  $('.address-edit-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.edit-address').slideUp();
  })

  $('.address-new-toggle').on('click', function(e) {
    e.preventDefault();
    $(this).closest('form').slideUp();
  })
}

export default addressToggle();



// WEBPACK FOOTER //
// ../markup/assets/js/account-address-toggle.js